import { useState, useRef, useEffect } from "react";

export default function ValidateCode({ length = 6, onComplete, verifyQuantity, prefillCode }) {
  const [values, setValues] = useState(Array(length).fill(""));
  const inputsRef = useRef([]);

  useEffect(() => {
    // Autofocus en el primer input al montar
    inputsRef.current[0]?.focus();
  }, []);

  useEffect(() => {
    if (!prefillCode) return;
    const digits = prefillCode.replace(/[^0-9]/g, "").slice(0, length);
    if (!digits) return;
    const newValues = Array(length).fill("");
    for (let i = 0; i < digits.length; i++) {
      newValues[i] = digits[i];
    }
    setValues(newValues);
    verifyQuantity(newValues.join(""));
    if (digits.length === length) {
      onComplete?.(digits);
    }
  }, [prefillCode]);

const handleChange = (e, index) => {
  const val = e.target.value.replace(/[^0-9]/g, ""); // Solo números
  if (!val) return;

  const newValues = [...values];
  newValues[index] = val.slice(0, 1); // Solo un dígito
  setValues(newValues);
  verifyQuantity(newValues.join(""));

  // Avanzar automáticamente al siguiente input si no es el último
  if (index < length - 1) {
    inputsRef.current[index + 1]?.focus();
  }

  // Verificar si se completó el código
  if (newValues.every((digit) => digit !== "")) {
    onComplete?.(newValues.join(""));
  }
};

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newValues = [...values];

      if (values[index]) {
        // Si hay valor, lo borramos
        newValues[index] = "";
        setValues(newValues);
        verifyQuantity(newValues.join(""));
      } else if (index > 0) {
        // Si está vacío, limpiar el anterior y mover foco atrás
        newValues[index - 1] = "";
        setValues(newValues);
        verifyQuantity(newValues.join(""));
        inputsRef.current[index - 1]?.focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").replace(/[^0-9]/g, "").slice(0, length);
    const newValues = Array(length).fill("");

    // Llenar los valores con los dígitos pegados
    for (let i = 0; i < paste.length; i++) {
      newValues[i] = paste[i];
    }

    setValues(newValues);
    verifyQuantity(newValues.join(""));

    // Si se completó el código, ejecutar onComplete
    if (paste.length === length) {
      onComplete?.(paste);
    } else {
      // Enfocar el siguiente input disponible
      inputsRef.current[paste.length]?.focus();
    }
  };

  return (
    <div className="flex justify-center space-x-2" onPaste={handlePaste}>
      {values.map((val, i) => (
        <input
          key={i}
          ref={(el) => (inputsRef.current[i] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={val}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          className="w-12 h-12 text-center border rounded-lg focus:ring-2 focus:ring-aw-green text-lg"
        />
      ))}
    </div>
  );
}
